import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./insurance.scss";

// images
import menuBg from "../../assets/images/bg/menu/home.svg";
import Disclaimer from "../../components/disclaimer";
import FooterBottom from "../../components/footerBottom";

// components
import Header from "../../components/header";
import HeroSection from "../../components/insurance/HeroSection";
import MainMenu from "../../components/mainMenu";
import SignupModal from "../../components/signupModal";
import Why from "../../components/insurance/Why";
import CallToAction from "../../components/insurance/calltoaction";
import { getInsuranceListAction, getInsuranceCMSData } from "../admin/dashboard/actions";
import { Element } from "react-scroll";
import parse from "html-react-parser";
import { connect } from "react-redux";
import SatisfactionGuaranteed from "./SatisfactionGuaranteed";
import logo from "../../assets/images/logo.png";
import typeBg from "../../assets/images/insurance-assets/type-gradient.png";
import FAQSection from "../FaqSection/FAQSection";

const Index = (props) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [keyword, setKeyword] = useState("");

  const handleOpenMenu = () => {
    setOpenMenu(!openMenu);
  };

  const handleCloseMenuMenu = () => {
    setOpenMenu(false);
  };

  useEffect(() => {
    props.getInsuranceListAction();
    props.getInsuranceCMSData();
  }, []);

  const data = props?.insurance_cms;

  useEffect(() => {
    if (props?.insurance_cms?.keywords?.length > 0) {
      const dataKeyword = props?.insurance_cms?.keywords;
      const pp = dataKeyword.toString();
      setKeyword(pp);
    }
  }, [props?.insurance_cms?.keywords]);

  return (
    <>
      <Helmet>
        <title>Affordable Insurance for Therapists - Clarity Cooperative</title>
        <meta name="title" content={"Affordable Insurance for Therapists - Clarity Cooperative"} />
        <meta name="description" content={props?.insurance_cms?.excerpt} />
        <meta name="keywords" content={keyword} />
        <meta property="og:title" content={"Affordable Insurance for Therapists - Clarity Cooperative"} />
        <meta property="og:url" content={props?.insurance_cms?.url} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={logo} />
        <meta property="og:site_name" content="clarity cooperative" />
        <meta property="og:description" content={props?.insurance_cms?.excerpt} />
        <meta name="twitter:card" content={props?.insurance_cms?.excerpt} />
        <meta property="twitter:domain" content="ccdev.brethren.io" />
        <meta property="twitter:url" content={props?.insurance_cms?.url} />
        <meta name="twitter:title" content={"Affordable Insurance for Therapists - Clarity Cooperative"} />
        <meta name="twitter:description" content={props?.insurance_cms?.excerpt} />
        <meta name="twitter:image" content={logo} />
      </Helmet>
      <MainMenu closeMenu={handleCloseMenuMenu} title="NAVIGATE" bgImage={menuBg} className={openMenu ? "active" : ""} />
      <Header openMenu={handleOpenMenu} className="headerStyleBlack" blackLogo />

      <HeroSection data={data} />
      <Element name="calltoaction">
        <CallToAction data={data} />
      </Element>

      <Element name="why">
        <Why data={data} />
      </Element>

      <section className="section insurancetype bg-norepeat" id="insurance-type" style={{ backgroundImage: `url(${typeBg})` }}>
        <Container className="">
          <Row className="mb-5 pb-3">
            <Col xl={8} lg={10} xs={12} className="mx-auto text-center">
              <h2 className="text-white">{parse(data?.plan_title || "") || ""}</h2>
              <h6 className="text-xxl my-4">{data?.plan_sub_title || ""}</h6>
              <p className="text-xxl">{data?.plan_details || ""}</p>
            </Col>
          </Row>

          <div className="type-info">
            {props?.insurances?.insurances?.map((item) => (
              <Link to={`/insurance/${item.slug}`} key={item.id}>
                <div className="info-box bg-white text-center d-flex align-items-center justify-content-center">
                  <img src={item.icon} alt="" />
                  <p className="mt-5 text-xl">{item.name}</p>
                </div>
              </Link>
            ))}
          </div>
        </Container>
      </section>

      <SatisfactionGuaranteed data={data} />

      {data?.faq?.length > 0 && (
        <section className="faqSection section bg-white py-0">
          <FAQSection
            FAQs={data?.faq || []}
            title="<h1>Frequently Asked Questions</h1>"
            description="Learn more about how health insurance plans work through the Cooperative"
          />
        </section>
      )}

      <Disclaimer data={data} />

      {/* <Footer /> */}
      <FooterBottom />
      <SignupModal show={isModal} onHide={() => setIsModal(false)} />
    </>
  );
};

const mapStateToProps = (state) => ({
  insurances: state.admin.insurances,
  insurance_cms: state.admin.insurance_cms,
});

export default connect(mapStateToProps, {
  getInsuranceListAction,
  getInsuranceCMSData,
})(Index);
